import React, { useState } from "react";
import SendArrow from "../../../Icons/SendArrow";
import { completeSurvey } from "../../AppContainer";
import "./ChatInput.css";

const ChatInput = ({ inputPlaceholder, textareaHeight, chatInputRef, replyValue, setReplyValue, chatInputDisabled, sendReplyQuestion, onTextChange }) => {
  const [isActive, setIsActive] = React.useState(false);

  return (
    <div className="chat-input-bar">
      {chatInputDisabled ?
        (
          <div className="complete">Thank you for participating!</div>
        ) : (
          <React.Fragment>
            <textarea className="chat-input"
              ref={chatInputRef}
              onFocus={() => setIsActive(true)}
              onBlur={() => setIsActive(false)}
              name="answer"
              placeholder={inputPlaceholder || "Type your message here..."}
              onKeyDown={e => onTextChange(e, replyValue)}
              style={{ height: `${textareaHeight}px` }}
              onChange={e => setReplyValue(e.target.value)}
              value={replyValue}
            />
            <button className="chat-send-button" onClick={() => sendReplyQuestion(replyValue)}>
              <SendArrow className={`chat-send-arrow ${isActive ? "active" : ""}`} />
            </button>
          </React.Fragment>
        )
      }
    </div>
  );
};

export default ChatInput;